function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.798 7c0 .953-.806 1.725-1.801 1.725-.995 0-1.802-.772-1.802-1.726 0-.953.807-1.726 1.802-1.726S8.798 6.046 8.798 7zM7 3.404c-1.03.005-2.098.256-3.109.736a7.919 7.919 0 00-2.117 1.541C1.462 6.012 1.064 6.49 1 7c.008.441.481.987.774 1.317A7.8 7.8 0 003.89 9.86 7.288 7.288 0 007 10.595c1.031-.005 2.099-.259 3.109-.736a7.924 7.924 0 002.117-1.542c.312-.33.71-.807.774-1.317-.008-.442-.481-.987-.774-1.318a7.803 7.803 0 00-2.117-1.541A7.33 7.33 0 007 3.405zm0 .893c1.56 0 2.826 1.21 2.826 2.702 0 1.493-1.266 2.703-2.827 2.703S4.172 8.493 4.172 7c0-1.492 1.266-2.702 2.827-2.702z",
  fill: "currentColor"
});

var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgView;